import { render, staticRenderFns } from "./CalendarEdit.vue?vue&type=template&id=f4986d44&scoped=true"
import script from "./CalendarEdit.vue?vue&type=script&lang=js"
export * from "./CalendarEdit.vue?vue&type=script&lang=js"
import style0 from "./CalendarEdit.vue?vue&type=style&index=0&id=f4986d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4986d44",
  null
  
)

export default component.exports